var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { dateObjectOrNull } from "../../helpers/date";
import { CartItem } from "./CartItem";
import { currency } from "../../helpers";
var BookedOutCartItem = /** @class */ (function (_super) {
    __extends(BookedOutCartItem, _super);
    function BookedOutCartItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isBookedOut = true;
        _this.isRoot = _this.props.grandParentId === null;
        return _this;
    }
    Object.defineProperty(BookedOutCartItem.prototype, "timespanId", {
        get: function () {
            var _a, _b;
            var id = (_b = (_a = this.dirtyCartItem) === null || _a === void 0 ? void 0 : _a.booking) === null || _b === void 0 ? void 0 : _b.course_timespan_id;
            return id ? String(id) : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BookedOutCartItem.prototype, "quantity", {
        get: function () {
            var _a, _b;
            return String(((_b = (_a = this.dirtyCartItem) === null || _a === void 0 ? void 0 : _a.position) === null || _b === void 0 ? void 0 : _b.quantity) || 0);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BookedOutCartItem.prototype, "onDate", {
        get: function () {
            var _a;
            return (_a = this.dirtyCartItem) === null || _a === void 0 ? void 0 : _a.onDate;
        },
        enumerable: false,
        configurable: true
    });
    ;
    Object.defineProperty(BookedOutCartItem.prototype, "bookingSlot", {
        get: function () {
            var _a;
            return (_a = this.dirtyCartItem) === null || _a === void 0 ? void 0 : _a.bookingSlot;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BookedOutCartItem.prototype, "_booking", {
        get: function () {
            var _a, _b;
            return {
                to: dateObjectOrNull((_a = this.bookingSlot) === null || _a === void 0 ? void 0 : _a.to) || undefined,
                from: dateObjectOrNull((_b = this.bookingSlot) === null || _b === void 0 ? void 0 : _b.from) || undefined,
                course_timespan_id: this.timespanId,
                quantity: this.quantity,
                personal_data_index: this.personalDataIndex
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BookedOutCartItem.prototype, "_position", {
        get: function () {
            return {
                price_id: this.priceId,
                quantity: this.quantity,
                parent_price_id: this.parentPriceId
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BookedOutCartItem.prototype, "dirtyCartItem", {
        get: function () {
            return this.props.dirtyItem;
        },
        enumerable: false,
        configurable: true
    });
    BookedOutCartItem.prototype.getAsRowItem = function () {
        var _a;
        return [{
                id: this.priceId || this.timespanId,
                quantity: 0,
                sumTotal: 0,
                sumTotalFormatted: currency(0).format(),
                title: ((_a = this.timespan) === null || _a === void 0 ? void 0 : _a.getAsTitle([], {})) || "",
            }];
    };
    BookedOutCartItem.prototype.toResponseObject = function (sanitizedState) {
        return [];
    };
    return BookedOutCartItem;
}(CartItem));
export { BookedOutCartItem };
